import { bindServices } from '@/services/api';
import { queryEditActive } from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const api = bindServices('configManageNotification');

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'processNotification',
  state: {
    newNotification: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select: 'id,emails,status',
    notSelectSearch: 'status,users',
    expand: {
      users: { expand: { user: { select: 'fullName' } } },
    },
    paramsView: {
      select: 'id,emails,status,isSendToApplicantEnabled,created,updated',
      expand: {
        users: { expand: { user: { select: 'fullName' } } },
      },
    },
    paramsEdit: {
      select: 'id,emails,status,isSendToApplicantEnabled',
      expand: {
        users: { expand: { user: { select: 'fullName' } } },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'processCustomNotification/paged',
          params: payload,
        });
        yield put({
          type: 'queryNotifications',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewNotification({ payload }, { put }) {
      yield put({
        type: 'addNotification',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewNotification',
          payload,
        });
      }
    },

    *editItemNotification({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'processCustomNotification',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editNotification',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewNotification({ payload }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'processCustomNotification',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditNotification({ payload }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'processCustomNotification',
          data: payload.data,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(api.apiRoute, {
          route: `processCustomNotification/${id}`,
          method: 'delete',
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveNotification',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *editActive({ payload, params }, { call, put }) {
      try {
        yield call(queryEditActive, params);
        yield put({
          type: 'editActives',
          payload,
        });
      } catch (error) {
        /* try */
      }
    },

    *showItemNotification({ view }, { put }) {
      yield put({
        type: 'showEditItemNotification',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryNotifications(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addNotification(state, { payload }) {
      return {
        ...state,
        newNotification: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewNotification(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editNotification(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveNotification(state, { payload }) {
      return {
        ...state,
        saveNotification: payload,
        newNotification: false,
        selectedItem: false,
      };
    },

    showEditItemNotification(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    editActives(state, { payload }) {
      const list = state.list.map((item) => (item.id === payload.id ? payload : item));

      return {
        ...state,
        list,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newNotification: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
